import { Body, H2 } from '@/components/atoms/typography'
import { Flex } from '@/components/atoms/Grid'
import { FC } from 'react'
import styled from 'styled-components'
import { MediaContextProvider } from '../atoms/media'

type ProductListingTitleCountInfoRedesignProps = {
  title: string
  additionalInfo?: string
} & Rest

const ProductListingTitleCountInfoRedesign: FC<ProductListingTitleCountInfoRedesignProps> =
  ({ title, additionalInfo, ...rest }) => {
    const cleanInfo = additionalInfo?.replace(/[()]/g, '')

    return (
      <MediaContextProvider>
        <Flex
          flexDirection="row"
          alignItems="center"
          mt={{ desktop: 0, tablet: 20, mobile: 20 }}
          mb={{ desktop: 32, tablet: 12, mobile: 12 }}
          {...rest}
        >
          <StyledTitle>{title}</StyledTitle>
          {additionalInfo && (
            <StyledAdditionalInfo>{cleanInfo}</StyledAdditionalInfo>
          )}
        </Flex>
      </MediaContextProvider>
    )
  }

export default ProductListingTitleCountInfoRedesign

const StyledAdditionalInfo = styled(Body)`
  display: inline-flex;
  align-items: center;
  padding: 4px 6px;
  margin: 0;
  line-height: normal;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.navMenuGrey};
  color: ${(props) => props.theme.colors.buttonColorNew};
  font-weight: 400;
  font-size: 12px;
`

const StyledTitle = styled(H2)`
  margin: 0 8px 0 0;
  line-height: normal;
  font-size: 20px;
`
